'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Envelope = require('./envelope');

var PeerRecord = require('./peer-record');
/**
 * @typedef {import('../')} Libp2p
 */

/**
 * Create (or update if existing) self peer record and store it in the AddressBook.
 *
 * @param {Libp2p} libp2p
 * @returns {Promise<void>}
 */


function updateSelfPeerRecord(_x) {
  return _updateSelfPeerRecord.apply(this, arguments);
}

function _updateSelfPeerRecord() {
  _updateSelfPeerRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(libp2p) {
    var peerRecord, envelope;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            peerRecord = new PeerRecord({
              peerId: libp2p.peerId,
              multiaddrs: libp2p.multiaddrs
            });
            _context.next = 3;
            return Envelope.seal(peerRecord, libp2p.peerId);

          case 3:
            envelope = _context.sent;
            libp2p.peerStore.addressBook.consumePeerRecord(envelope);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateSelfPeerRecord.apply(this, arguments);
}

module.exports.updateSelfPeerRecord = updateSelfPeerRecord;